import script from "./FriendButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendButton.vue?vue&type=script&setup=true&lang=js"

import "./FriendButton.vue?vue&type=style&index=0&id=b591ab74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b591ab74"]])

export default __exports__